import { useEffect, useState } from "react";

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);

    // Funzione di callback per aggiornare lo stato delle corrispondenze
    const handleMediaQueryChange = (event) => {
      setMatches(event.matches);
    };

    // Aggiungi il listener per il cambiamento della media query
    mediaQuery.addEventListener("change", handleMediaQueryChange);

    // Verifica la corrispondenza iniziale della media query
    setMatches(mediaQuery.matches);

    // Pulisci l'eventuale listener quando il componente viene smontato
    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, [query]);

  return matches;
};

export default useMediaQuery;
